import Marionette from 'backbone.marionette';
import journalVoteItemviewTmpl from '../templates/journal_vote_itemview.tpl';
export default Marionette.ItemView.extend({
  template: journalVoteItemviewTmpl,
  tagName: "tr"
});